import React, { useEffect } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CustomButton from "../../../../components/buttons/CustomButton";
import CheckStatusList from "./CheckStatusList";
import styles from "./CranialSteps.module.css";

const LOCAL_CHECKS = [
  { key: "file", label: "Formato e tamanho do arquivo" },
  { key: "resolution", label: "Resolução" },
  { key: "brightness", label: "Iluminação" },
  { key: "sharpness", label: "Nitidez" },
];

const STATUS_TEXT = {
  approved: "A foto passou na verificação local.",
  approved_with_warnings: "A foto pode ser usada, mas alguns pontos podem reduzir a precisão.",
  rejected: "Esta foto não pode ser usada para a medição.",
};

/**
 * Local deterministic validation. Runs once on entry and lets the user
 * continue, continue despite warnings, or pick another photo.
 */
function ImageValidationStep({ validation, cameraAvailable, onValidate, onContinue, onRetakeCamera, onChooseAnother }) {
  useEffect(() => {
    if (!validation) onValidate();
    // Runs on entry only; a new photo remounts the step with validation reset.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const issues = validation ? [...validation.problems, ...validation.warnings] : [];
  const items = LOCAL_CHECKS.map((check) => {
    const related = issues.filter((entry) => entry.check === check.key);
    return {
      ...check,
      status: validation ? validation.checks[check.key] : null,
      message: related.map((entry) => entry.message).join(" "),
    };
  });

  const status = validation && validation.status;

  return (
    <div className={styles.card}>
      <span className={styles.eyebrow}>Verificação</span>
      <h3 className={styles.cardTitle}>{validation ? "Verificação da foto" : "Verificando a foto..."}</h3>
      <p className={styles.cardText}>
        {status ? STATUS_TEXT[status] : "Conferindo formato, resolução, iluminação e nitidez."}
      </p>

      <CheckStatusList items={items} />

      {status && status !== "rejected" && (
        <div className={styles.notice}>
          <LockOutlinedIcon fontSize="small" className={styles.noticeIcon} />
          <span>
            Na próxima etapa a foto será enviada para processamento e não fica armazenada. A análise
            automática também confere o enquadramento, a perspectiva e a visibilidade do contorno.
          </span>
        </div>
      )}

      {status === "rejected" && (
        <div className={styles.actions}>
          {cameraAvailable && (
            <CustomButton variant="outlined" style="primary" label="Tirar outra foto" icon={<PhotoCameraOutlinedIcon />} onClick={onRetakeCamera} />
          )}
          <CustomButton variant="contained" style="primary" label="Escolher outra imagem" icon={<FileUploadOutlinedIcon />} onClick={onChooseAnother} />
        </div>
      )}

      {status === "approved_with_warnings" && (
        <div className={styles.actions}>
          <CustomButton variant="outlined" style="primary" label="Escolher outra" icon={<FileUploadOutlinedIcon />} onClick={onChooseAnother} />
          <CustomButton variant="contained" style="primary" label="Continuar mesmo assim" icon={<ArrowForwardIcon />} onClick={onContinue} />
        </div>
      )}

      {status === "approved" && (
        <div className={styles.actions}>
          <CustomButton variant="outlined" style="primary" label="Escolher outra" icon={<FileUploadOutlinedIcon />} onClick={onChooseAnother} />
          <CustomButton variant="contained" style="primary" label="Continuar" icon={<ArrowForwardIcon />} onClick={onContinue} autoFocus />
        </div>
      )}
    </div>
  );
}

export default ImageValidationStep;
